export default __webpack_public_path__ + "a483cb80efd9ed6ae372586518a3bb78.svg";